var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 97,
    viewBox: "0 0 84 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M51.0826 0.5H0.825684V89.1605H69.8532V18.7018L51.0826 0.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M69.8532 18.7018L51.0825 0.5V18.7018H69.8532Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2487",
    x: 5.66968,
    y: 16.6465,
    width: 38.1468,
    height: 2.34862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2490",
    x: 5.66968,
    y: 36.0234,
    width: 58.7339,
    height: 2.34862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2491",
    x: 5.66968,
    y: 42.4824,
    width: 58.7339,
    height: 2.34862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2493",
    d: "M5.66968 55.3984H41.3944V57.7471H5.66968V55.3984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2492",
    x: 5.66968,
    y: 48.9395,
    width: 38.1468,
    height: 2.34862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2494",
    x: 5.66968,
    y: 61.8574,
    width: 35.1193,
    height: 2.34862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2495",
    x: 5.66968,
    y: 74.7754,
    width: 58.7339,
    height: 2.34862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2496",
    x: 5.66968,
    y: 68.3164,
    width: 38.1468,
    height: 2.34862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2489",
    x: 5.66968,
    y: 29.5645,
    width: 38.1468,
    height: 2.34862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2488",
    x: 5.66968,
    y: 23.1055,
    width: 38.1468,
    height: 2.34862,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2497",
    x: 41.3945,
    y: 55.3984,
    width: 23.0092,
    height: 4.69725,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2498",
    x: 41.3945,
    y: 61.8574,
    width: 23.0092,
    height: 4.69725,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.8319 93.7507L69.0153 75.5196C69.8342 74.9087 70.6007 74.2347 71.3075 73.5043C74.2536 70.4494 76.0405 66.5154 76.375 62.3476C76.7094 58.1797 75.5717 54.0255 73.1484 50.5664C70.725 47.1072 67.16 44.5485 63.0381 43.3101C58.9162 42.0716 54.4821 42.2268 50.4633 43.7504C46.4445 45.2739 43.0795 48.0752 40.9203 51.6948C38.7611 55.3144 37.936 59.5374 38.5803 63.671C39.2245 67.8045 41.2999 71.6033 44.466 74.4441C47.6321 77.2849 51.7009 78.9991 56.0049 79.3054C56.6836 79.3535 57.3645 79.3655 58.0445 79.3414C60.8104 79.2591 63.5242 78.5908 65.9949 77.3837L79.9527 95.802C80.2348 96.1699 80.6561 96.4144 81.1241 96.4819C81.5922 96.5494 82.0687 96.4343 82.4492 96.1619C82.8287 95.8903 83.0818 95.4844 83.1535 95.0327C83.2252 94.581 83.1096 94.1202 82.8319 93.7507ZM57.9405 75.8866C57.388 75.9042 56.835 75.8946 56.2836 75.8578C52.333 75.582 48.6423 73.8482 45.9727 71.0139C43.3031 68.1796 41.8581 64.461 41.9358 60.625C42.0135 56.789 43.6079 53.1282 46.3901 50.3975C49.1724 47.6667 52.9304 46.0744 56.8891 45.9488C57.4478 45.9307 58.0071 45.9415 58.5646 45.9812C62.509 46.2667 66.1905 48.0056 68.8517 50.8402C71.513 53.6748 72.9516 57.3895 72.8716 61.2202C72.7917 65.0509 71.1993 68.7062 68.4219 71.4343C65.6446 74.1624 61.8936 75.7558 57.9405 75.8866Z",
    fill: "#E3E3E3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoData);
export default __webpack_public_path__ + "static/media/icNoData.ce5800c74c5a63ba2303c464ff0ac54d.svg";
export { ForwardRef as ReactComponent };